import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';

export const isProductCreateForbiddenMessage = (message) => {
  const text = String(message || '');
  return text.includes('تولید محصول') || /plus or higher|create a product/i.test(text);
};

export const PackagePricingLink = ({ children, className }) => (
  <Link
    to="/pricing"
    className={className || 'font-bold underline decoration-2 underline-offset-4 hover:opacity-80'}
  >
    {children}
  </Link>
);

export const ProductCreateErrorMessage = () => {
  const { t } = useI18n();
  return (
    <p>
      {t('productCreateForbidden')}{' '}
      <PackagePricingLink>{t('pricingPurchaseTitle')}</PackagePricingLink>
    </p>
  );
};

export const ProductCreateBanner = ({ entitlement }) => {
  const { t } = useI18n();
  if (!entitlement || entitlement.canCreateProduct) {
    return null;
  }

  return (
    <div className="mb-3 overflow-hidden rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-start dark:border-amber-500/30 dark:bg-amber-500/10">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-200">
          <Sparkles size={18} strokeWidth={2.2} />
        </span>
        <div className="min-w-0 flex-1 text-sm leading-6 text-amber-950 dark:text-amber-100">
          <p className="font-bold">
            {entitlement.hasPackage ? t('productCreateNeedsUpgrade') : t('productCreateNeedsPackage')}
          </p>
          <p className="mt-1 text-amber-900/80 dark:text-amber-100/80">
            {t('productCreateNeedsPackageHint')}{' '}
            <PackagePricingLink>{t('pricingPurchaseTitle')}</PackagePricingLink>
          </p>
        </div>
      </div>
    </div>
  );
};
